export default __webpack_public_path__ + "static/media/NewYorkCityandWestchesterCounty_Sgl_Black.6072129f.png";